const API_URL = process.env.REACT_APP_SERVER_URL;

export const getCourses = async (token) => {
  const res = await fetch(`${API_URL}/courses`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!res.ok) throw new Error("Failed to fetch courses");
  return res.json();
};

export const getCourse = async (courseSlug, token) => {
  const res = await fetch(`${API_URL}/courses/${encodeURIComponent(courseSlug)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!res.ok) throw new Error("Failed to fetch course");
  return res.json();
};

export const getCourseClass = async (courseSlug, classSlug, token) => {
  const res = await fetch(
    `${API_URL}/courses/${encodeURIComponent(courseSlug)}/classes/${encodeURIComponent(classSlug)}`,
    { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
  );
  const data = await res.json().catch(() => ({}));

  if (res.status === 403 && data.error === "locked") {
    return { locked: true, nisPrice: data.nisPrice || 0, rubPrice: data.rubPrice || 0, eurDisplayPrice: data.eurDisplayPrice || null };
  }
  if (!res.ok) throw new Error("Failed to fetch class");

  return { locked: false, data };
};

export const pollCourseUnlock = async (courseSlug, token, { attempts = 8, intervalMs = 2000 } = {}) => {
  let course = await getCourse(courseSlug, token);
  for (let i = 1; i < attempts && course.locked; i++) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
    course = await getCourse(courseSlug, token);
  }
  return course;
};

export const purchaseCourse = async (courseSlug, provider, token) => {
  const res = await fetch(`${API_URL}/courses/${encodeURIComponent(courseSlug)}/purchase`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ provider }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Failed to start course payment");
  return data;
};
